import { render, staticRenderFns } from "./PublicPageMenu.vue?vue&type=template&id=4899e0ba&scoped=true"
import script from "./PublicPageMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicPageMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PublicPageMenu.vue?vue&type=style&index=0&id=4899e0ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4899e0ba",
  null
  
)

export default component.exports